import React, { useCallback, useRef, useState } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import DashboardView from 'views/Administration/HiredNumber/Dashboard';
import PaymentService from 'api/Payment';
import AccountDirectDialService from 'api/AccountDirectDial';
import SettingsActions from 'store/reducers/Settings';
import { useFetchTableData } from 'hooks';
import { handlePromise } from 'utils';
import EditNumber from '../EditNumber';

const Dashboard = ( { parentPath, locale, toggleErrorAlert, user } ) => {
  const [dataSubmitted, setDataSubmitted] = useState( new Date().valueOf() );
  const [editNumberModal, setEditNumberModal] = useState( false );
  const toEditRef = useRef( null );

  const [fetchPayments, payments] = useFetchTableData( {
    promise: ( params ) => PaymentService.getPayments( { ...params, 'filters[typeIn]': ['ddi'] } ),
    toggleErrorAlert,
    deps: [],
  } );

  const [fetchPhoneNumbers, phoneNumbers, phoneNumbersLoading] = useFetchTableData( {
    promise: AccountDirectDialService.getDdis,
    toggleErrorAlert,
    deps: [dataSubmitted],
  } );

  const reloadPhoneNumbers = useCallback( () => {
    if ( editNumberModal ) setEditNumberModal( false );
    setDataSubmitted( new Date().valueOf() );
  }, [editNumberModal] );

  const downloadInvoice = useCallback( async ( id ) => {
    const [errors, response, responseData] = await handlePromise( PaymentService.getInvoice( id ) );
    if ( !response.ok ) return toggleErrorAlert( errors );
    window.open( responseData.uri );
  }, [toggleErrorAlert] );

  const toggleEditNumberModal = useCallback( ( id ) => {
    toEditRef.current = id;
    setEditNumberModal( ( state ) => !state );
  }, [] );

  return (
    <>
      <DashboardView
        payments={payments}
        locale={locale}
        phoneNumbers={phoneNumbers}
        // isLoading={paymentsLoading || phoneNumbersLoading}
        isLoading={ phoneNumbersLoading}
        parentPath={parentPath}
        onFetchPayments={fetchPayments}
        onFetchPhoneNumbers={fetchPhoneNumbers}
        onReloadPhoneNumbers={reloadPhoneNumbers}
        onEditPhoneNumber={toggleEditNumberModal}
        onDownloadInvoice={downloadInvoice}
        userData={user}
      />

      {editNumberModal
      && (
        <EditNumber
          entityId={toEditRef.current}
          open={editNumberModal}
          onClose={toggleEditNumberModal}
          onConfirm={reloadPhoneNumbers}
        />
      )}
    </>
  );
};

const mapStateToProps = ( { user, settings } ) => ( {
  user,
  locale: _.get( settings, 'locale.locale' ),
} );

const mapDispatchToProps = ( {
  toggleErrorAlert: SettingsActions.toggleErrorAlert,
} );

export default connect( mapStateToProps, mapDispatchToProps )( Dashboard );
